module.exports = {
  siteTitle: "Amita Shukla", // <title>
  shortSiteTitle: "Amita Shukla", // <title> ending for posts and pages
  siteDescription: "Amita Shukla's Personal Website",
  siteUrl: "https://www.amitashukla.in",
  // pathPrefix: "",
  siteImage: "preview.png",
  siteLanguage: "en",

  /* author */
  authorName: "Amita Shukla",
  authorTwitter: "https://twitter.com/amita__shukla",
  authorGithub: "https://github.com/amita-shukla",
  authorStackoverflow: "http://stackoverflow.com/users/3858467/amita",
  authorLinkedin: "https://in.linkedin.com/in/shuklaamita",
  authorPocket: "https://getpocket.com/@amita0906",
  authorGoodreads: "https://www.goodreads.com/amita_shukla",

  /* header text */
  headerTitle: "Amita Shukla",
  headerSubTitle: "blog by Amita Shukla",

  /* manifest.json */
  manifestName: "Amita Shukla",
  manifestShortName: "Amita Shukla", // max 12 characters
  manifestStartUrl: "/index.html",
  manifestBackgroundColor: "white",
  manifestThemeColor: "#666",
  manifestDisplay: "standalone",

  // gravatar
  // Use your Gravatar image. If empty then will use src/images/jpg/avatar.jpg
  // Replace your email adress with md5-code.
  // Example https://www.gravatar.com/avatar/g.strainovic@gmail.com ->
  // gravatarImgMd5: "https://www.gravatar.com/avatar/1db853e4df386e8f699e4b35505dd8c6",
  gravatarImgMd5: "",
};
